"use client";

import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CarouselContentProps } from "../types";
import { useCarousel, useCarouselStore } from "./carousel-provider";

function CarouselContent({ className, ...props }: CarouselContentProps) {
  const { emblaRef } = useCarousel();
  const orientation = useCarouselStore(store => store.orientation);

  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <div
      ref={emblaRef}
      className={cn("overflow-hidden h-full", className, classes)}
      data-slot="carousel-content"
    >
      <div
        className={cn(
          "flex",
          orientation === "horizontal" ? "-ml-4" : "-mt-4 flex-col",
        )}
        {...native}
      />
    </div>
  );
}

export default CarouselContent;
